import type { PartnerAccountSummary, PartnerUser } from '@upweo/types';
import { createContext, useContext } from 'react';

/**
 * Context and hook, kept apart from the provider component so React Fast
 * Refresh can preserve state — a combined module remounts every consumer on
 * each keystroke, which for an auth provider means being logged out mid-edit.
 */
export interface PartnerState {
  readonly user: PartnerUser | null;
  readonly activeAccount: PartnerAccountSummary | null;
  readonly isLoading: boolean;
  readonly signIn: (email: string, password: string) => Promise<void>;
  readonly signOut: () => Promise<void>;
  readonly selectAccount: (accountId: string) => void;
}

export const PartnerContext = createContext<PartnerState | null>(null);

export const usePartner = (): PartnerState => {
  const context = useContext(PartnerContext);
  if (!context) {
    throw new Error('usePartner must be used inside <PartnerProvider>');
  }
  return context;
};
